<template>
  <base-wrapper :loading="loadingOrder">
    <div class="space-y-4">
      <div class="flex items-center justify-end gap-2">
        <base-select
          :shadow="false"
          :options="filterOrderStatusOptions"
          v-model="filter.freeReimbursementStatus"
          @change="loadOrders"
        />
        <base-input
          type="search"
          :shadow="false"
          placeholder="Cari Kode atau Nama"
          debounce
          v-model="filter.search"
          @native-input="loadOrders"
        />
      </div>

      <datatable
        :columns="tableColumns"
        :total="orders.meta.page.total"
        :perPage="orders.meta.page.perPage"
        :currentPage="orders.meta.page.currentPage"
        :meta="orders.meta"
        @pagechanged="onChangePage"
      >
        <template #tbody="{ classes }">
          <tr
            v-for="order in orders.data"
            :key="order.id"
            :class="[classes.tr, 'cursor-pointer bg-white hover:bg-green-100']"
            @click="onClickDetail(order.attributes.order_id)"
          >
            <td :class="[classes.td, 'space-y-1']">
              <order-code-label :order="order" />
              <order-date-label :order="order" class="text-xs text-gray-500" />
            </td>
            <td :class="[classes.td, 'text-right']">
              {{
                getSingleIncluded(orders, order.relationships.order.data.id)
                  .attributes.grand_total_pv | toCurrency
              }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{
                getSingleIncluded(orders, order.relationships.order.data.id)
                  .attributes.total_bonus_value | toCurrency
              }}
            </td>
            <td :class="[classes.td, 'text-right']">
              {{
                getSingleIncluded(orders, order.relationships['order'].data.id)
                  .attributes.grand_total_price | toCurrency
              }}
              <span
                v-if="
                  getSingleIncluded(
                    orders,
                    order.relationships['order'].data.id
                  ).attributes.grand_total_price !==
                  getSingleIncluded(
                    orders,
                    order.relationships['order'].data.id
                  ).attributes.grand_total_report_price
                "
                class="text-red-600"
                >*</span
              >
            </td>
            <td :class="[classes.td, 'text-center']">
              <base-badge color="indigo">{{
                getSingleIncluded(orders, order.relationships['order'].data.id).attributes.free_reimbursement_status_label
              }}</base-badge>
            </td>
          </tr>
        </template>
      </datatable>
    </div>

    <view-order-modal
      label="Reimburse"
      with-bonus
      :with-items="false"
      :with-payment="false"
      :columns="[
        'code',
        'warehouse',
        'office',
        'date',
        'user',
        'area',
        'shipment_type',
        'address',
      ]"
      :order-detail-columns="['code', 'qty', 'price', 'total_price', 'packed_qty', 'unpacked_qty']"
      :visible="detailModal.visible"
      :order-id="detailModal.orderId"
      readonly
      @close="detailModal.visible = false"
    />
  </base-wrapper>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import { mapGetters } from 'vuex';
import ViewOrderModal from '@/components/order/view-order-modal.vue';
import OrderCodeLabel from '@/components/order/order-code-label.vue';
import OrderDateLabel from '@/components/order/order-date-label.vue';

export default {
  mixins: [requestMixin],
  components: {
    ViewOrderModal,
    OrderCodeLabel,
    OrderDateLabel,
  },
  data() {
    return {
      filter: {
        search: null,
        freeReimbursementStatus: null
      },
      detailModal: {
        orderId: null,
        visible: false,
      },
      loadingOrder: false,
      orders: {
        data: [],
        meta: {
          page: {},
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
    }),
    tableColumns() {
      return [
        { id: 'code', name: 'Nomor Faktur' },
        { id: 'point', name: 'PV', theadClass: 'text-right' },
        { id: 'bonus', name: 'BV', theadClass: 'text-right' },
        {
          id: 'belanja',
          name: 'Total Harga',
          theadClass: 'text-right',
        },
        {
          id: 'order_status',
          name: 'Status',
          theadClass: 'text-center',
        },
      ];
    },
    filterOrderStatusOptions() {
      return [
        {
          key: 'null',
          label: 'Semua',
          value: null,
        },
        {
          key: 'diproses_gudang_pengiriman',
          label: 'Diproses Gudang Pengiriman',
          value: 'diproses_gudang_pengiriman'
        },
        {
          key: 'dikirim',
          label: 'Dikirim',
          value: 'dikirim'
        },
        {
          key: 'selesai',
          label: 'Selesai',
          value: 'selesai'
        }
      ];
    },
  },
  methods: {
    async loadOrders(params) {
      this.loadingOrder = true;

      const [res, err] = await this.request('/api/v1/orders', {
        params: {
          'page[size]': 5,
          include: 'order',
          'fields[simple-orders]':
            'order,order_type,origin_code,destination_code,updatedAt,order_status,order_id,createdAt,area',
          'fields[offices]': 'code',
          'fields[orders]': 'grand_total_price,grand_total_report_price,grand_total_pv,total_bonus_value,has_bundle,order_status,latest_cancel_description,free_reimbursement_status_label',
          'filter[destination_office_category_id]': 4,
          'filter[origin_warehouse_id]': this.me.current_warehouse,
          'filter[search]': this.filter.search,
          'filter[need_free_reimbursement]': true,
          'filter[free_reimbursement_status_in]': this.filter.freeReimbursementStatus,
          ...params,
        },
      });

      if (!err) {
        this.orders = res;
      }

      this.loadingOrder = false;
    },
    onChangePage(page) {
      this.loadOrders({
        'page[number]': page,
      });
    },
    onClickDetail(orderId) {
      this.detailModal.orderId = orderId;
      this.detailModal.visible = true;
    },
    onRefresh() {
      this.detailModal.visible = false;

      this.loadOrders();
    },
  },
  created() {
    this.loadOrders();
  },
};
</script>
